module.exports = __webpack_public_path__ + "img/helper.2f429bee.png";